import { DataLayer } from './data-layer';
import { BaseEntity } from './base-entity';
import { Severity } from './severity';

export interface DataLayerType extends BaseEntity {
  workspaces: string[];
  name: string;
  layers?: DataLayer[];
  color?: string;
  tags?: string[];
  icon?: string;
  description?: string;
  geoSource?: string;
  sorting: number;
  type: 'Point' | 'Polygon';
  defaultLayer?: number;
}

export interface POI {
  key: string;
  name: string;
  description?: string;
  address?: string;
  contact?: string;
  information?: string;
  geoPositionX?: number;
  geoPositionY?: number;
  group?: string;
  validation?: Severity;
  projection?: string;
  data?: any;
  [key: string]: any;
}

export const poiExportableValues: string[] = [
  'name',
  'description',
  'key',
  'coordinates',
  'address',
  'contact',
  'information',
  'group',
];

export const poiMarkdownValues: string[] = [
  'description',
  'address',
  'contact',
  'information',
];
